export const extractTokenFromUrl = (): string | undefined => {
    const path = window.location.pathname
        .replace('/schedule', '')
        .replace('/', '');

    return path || undefined;
}
